import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof';
import { ProductCarrierItemData } from './PalletStockScreen';

export const palletStockScreensGridId = 'PalletStockScreen.productsGrid';
export const palletStockScreensGridOptions: iDataGridDisplayOptions = {
    id: palletStockScreensGridId,
    columnAutoWidth: true,
    showBorders: false,
    allowColumnReordering: true,
    allowColumnResizing: true,
    width: '100%',
    height: '100%',
    filterRow: {
        visible: true,
    },
    groupPanel: {
        visible: true,
    },
    grouping: {
        autoExpandAll: true,
    },
    columnChooser: {
        allowSearch: true,
        enabled: true,
        height: 500,
        width: 400,
    },
    columnFixing: {
        enabled: true,
    },
    selection: {
        showCheckBoxesMode: 'none',
    },
    columns: [
        {
            dataField: nameof<ProductCarrierItemData>(
                (c) => c.carrierWarehouseStorageData!.warehouseName
            ),
            dataType: 'string',
            cellTemplate: 'WarehouseNameColumn',
            caption: 't~PalletStockScreen:productsGrid.warehouseName',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productName),
            caption: 't~PalletStockScreen:productsGrid.productName',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productId),
            caption: 't~PalletStockScreen:productsGrid.productId',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.id),
            caption: 't~PalletStockScreen:productsGrid.id',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.carrierTypeId),
            caption: 't~PalletStockScreen:productsGrid.carrierTypeId',
            cellTemplate: 'CarrierTypeAsyncColumn',
            minWidth: 230,
            allowFiltering: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.maximumStackLayers),
            caption: 't~PalletStockScreen:productsGrid.maximumStackLayers',
            headerCellTemplate: 'AllowedStacksHeader',
            dataType: 'number',
            width: 120,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.carrierStatus),
            caption: 't~PalletStockScreen:productsGrid.carrierStatus',
            filterValue: 'Unreserved',
            visible: false,
            lookup: {
                valueExpr: 'value',
                displayExpr: 'text',
                dataSource: [
                    {
                        text: 't~CarrierStatus:Unreserved',
                        value: 'Unreserved',
                    },
                    {
                        text: 't~CarrierStatus:Intransport',
                        value: 'Intransport',
                    },
                    {
                        text: 't~CarrierStatus:Prereservation',
                        value: 'Prereservation',
                    },
                    {
                        text: 't~CarrierStatus:Reservation',
                        value: 'Reservation',
                    },
                    {
                        text: 't~CarrierStatus:Loadingfinished',
                        value: 'Loadingfinished',
                    },
                    {
                        text: 't~CarrierStatus:Blocked',
                        value: 'Blocked',
                    },
                ],
            },
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockStatus),
            caption: 't~PalletStockScreen:productsGrid.stockStatus',
            filterValue: 'Unreserved',
            lookup: {
                valueExpr: 'value',
                displayExpr: 'text',
                dataSource: [
                    {
                        text: 't~CarrierStatus:Unreserved',
                        value: 'Unreserved',
                    },
                    {
                        text: 't~CarrierStatus:Intransport',
                        value: 'Intransport',
                    },
                    {
                        text: 't~CarrierStatus:Prereservation',
                        value: 'Prereservation',
                    },
                    {
                        text: 't~CarrierStatus:Reservation',
                        value: 'Reservation',
                    },
                    {
                        text: 't~CarrierStatus:Loadingfinished',
                        value: 'Loadingfinished',
                    },
                    {
                        text: 't~CarrierStatus:Blocked',
                        value: 'Blocked',
                    },
                ],
            },
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute1!.value),
            caption: 't~PalletStockScreen:productsGrid.Partia_IZ10',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute5!.value),
            caption: 't~PalletStockScreen:productsGrid.DataProd_IZ11',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute4!.value),
            caption: 't~PalletStockScreen:productsGrid.NajlDo_IZ17',
            visible: false,
        },
        /////
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.carrierStatusDescription),
            caption: 't~PalletStockScreen:productsGrid.carrierStatusDescription',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.isStackable),
            caption: 't~PalletStockScreen:productsGrid.isStackable',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.layersCount),
            caption: 't~PalletStockScreen:productsGrid.layersCount',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockStatusDescription),
            caption: 't~PalletStockScreen:productsGrid.stockStatusDescription',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.supplierName),
            caption: 't~PalletStockScreen:productsGrid.supplierName',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>(
                (c) => c.carrierWarehouseStorageData!.warehouseEntryDateTime
            ),
            caption:
                't~PalletStockScreen:productsGrid.carrierWarehouseStorageData.warehouseEntryDateTime',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>(
                (c) => c.carrierWarehouseStorageData!.warehouseEntryDocumentId
            ),
            caption:
                't~PalletStockScreen:productsGrid.carrierWarehouseStorageData.warehouseEntryDocumentId',
            visible: false,
        },
        // customowe fieldy :
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productUnitsOnCarrier),
            caption: 't~PalletStockScreen:productsGrid.productUnitsOnCarrier',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute3!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute6!.value),
            caption: 't~PalletStockScreen:productsGrid.NajlDo_IZ17',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute2!.value),
            caption: 't~PalletStockScreen:productsGrid.NajlepszeDo_IZ15',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute7!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute8!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute9!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute0!.value),
            visible: false,
        },
    ],
};
propsStore.insert(palletStockScreensGridOptions);
